import { useMutation } from "react-query";

import type { HcpServiceManager, PostServiceArgs } from "api/services/appointment/schemas/hcp_service";
import { useApiClient } from "api/useApiClient";

export const usePostService = () => {
  const client = useApiClient();

  return useMutation<HcpServiceManager, Error, PostServiceArgs>({ mutationFn: args => client.postService(args) });
};
